import { Machine } from './machine.type';
import { StartOptions } from '../enums/start-options.enum';
import { PlaylistDTO } from '../view-models/playlist-models/playlist-dto.model';

export class Monitor {
  MonitorHandler: string;
  MachinePhysicalAddress: string;
  MonitorTitle: string;
  IdAssignedPlaylist: number;
  IsPrimary: boolean;
  StartOptions: StartOptions;
  ScreenUniqueId: string;

  Machine: Machine;
  AssignedPlaylist: PlaylistDTO;
  BoundX: string;
  BoundY: string;
  DesktopVersion: string;

  constructor(values: any = {}) {
    Object.assign(this, values);
  }
}
